import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import Testimonials from "../components/marketing/Testimonials";
import ContactCTA from "../components/marketing/ContactCTA";
import { useContent } from "../context/ContentContext";

export default function TestimonialsPage() {
  const { testimonials } = useContent();
  return (
    <div data-testid="testimonials-page">
      <PageHeader
        overline="Voices of Rythmbara"
        title={<>Words from our <span className="italic gold-gradient-text">dancers</span>.</>}
        subtitle="Students and parents share what the Rythmbara journey has meant to them."
        image="https://images.unsplash.com/photo-1767725832200-e47769184e40?crop=entropy&cs=srgb&fm=jpg&q=85"
      />
      <Testimonials items={testimonials} />
      <ContactCTA />
    </div>
  );
}
